import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./constants/routes";
import Login from "containers/Login /Login";
import Tenants from "containers/Tenants/Tenants";
import OnBoarding from "containers/OnBoarding/OnBoarding";
import CreateTenant from "containers/CreateTenant/CreateTenant";
import Branch from "containers/Branch/Branch";
import Schools from "containers/Schools/Schools";
import CreateSchool from "containers/CreateSchool/CreateSchool";
import SchoolDetails from "containers/SchoolDetails/SchoolDetails";
import TenantDetails from "containers/TenantDetails/TenantDetails";
import BranchDetails from "containers/BranchDetails/BranchDetails";
import CreateBranch from "containers/CreateBranch/CreateBranch";
import AuthenticatedRoute from "components/AuthenticatedRoute";
import UploadTenants from "containers/UploadTenants/UploadTenants";
import UploadBranches from "containers/UploadBranches/UploadBranches";
import Unauthorized from "containers/Unauthorized/Unauthorized";


const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to={routes.tenants.tenants} />} />
    <Route path={routes.login.root} element={<Login />} />
    <Route
      path={routes.unauthorized.unauthorized}
      element={<Unauthorized variant="standalone" />}
    />

    <Route element={<AuthenticatedRoute />}>
      <Route path={routes.tenants.tenants} element={<Tenants />} />
      <Route path={routes.onBoarding.onBoarding} element={<OnBoarding />} />
      <Route path={routes.createTenant.createTenant} element={<CreateTenant />} />
      <Route path={routes.branch.branch} element={<Branch />} />
      <Route path={routes.tenantDetails.tenantDetails} element={<TenantDetails />} />
      <Route path={routes.branchDetails.branchDetails} element={<BranchDetails />} />
      <Route path={routes.createBranch.createBranch} element={<CreateBranch />} />
      <Route path={routes.uploadTenants.uploadTenants} element={<UploadTenants />} />
      <Route path={routes.uploadBranches.uploadBranches} element={<UploadBranches />} />
      <Route path={routes.schools.schools} element={<Schools />} />
      <Route path={routes.createSchool.createSchool} element={<CreateSchool />} />
      <Route path={routes.schoolDetails.schoolDetails} element={<SchoolDetails />} />
    </Route>
  </Routes>
);

export default AppRoutes;
